export function getContentPageKey(slug: string, type: string) {
  return `${slug}:${type}`
}
